import { graphql } from '@api/generated';

export const isCallContinuityActiveQuery = graphql(`
  query isCallContinuityActive {
    isCallContinuityActive
  }
`);
